/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import {
  HttpClient,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { catchError, Observable } from "rxjs";
import * as moment from "moment";
import { FetchData } from "app/shared/generalMethods";

interface StaffProfile {
  Id: string;
  Staff_Name__c: string;
  Staff_Email__c: string;
  Staff_Phone__c: string;
  Staff_Address__c: string;
  Staff_Image__c: string;
  Community__c: string;
}

@Injectable()
export class StaffService {
  headers: HttpHeaders;
  options: any;
  serverUrl = environment.apiUrl;
  serverCache = environment.apiUrlCache;
  getStaffByUID: any;

  constructor(
    private http: HttpClient,
    private _httpClient: HttpClient,
    private _fetchData: FetchData
  ) {}

  getAdminByUID(id): Observable<any> {
    const url = this.serverUrl + "/adminByUID?id=" + id;
    return this._httpClient.get(url, this.options);
  }

  addStaff(payload: any, adminId: string): Observable<any> {
    const url = this.serverUrl + "/addStaff?adminId=" + adminId;
    const requestBody = {
      administrator: adminId,
      name: payload.name, // Use the form field names directly
      email: payload.email,
      address: payload.address,
      isActive: payload.isActive,
      role: payload.role,
      cellPhone: payload.cellPhone,
      password: payload.password,
      firebaseId: payload.firebaseUid,
      permissions: payload.permissions,
      organization: payload.organization,
    };
    return this.http.post(url, requestBody).pipe(
      catchError((error) => {
        console.error("API Error:", error);
        throw new Error(error.error?.error || "Failed to add staff");
      })
    );
  }

  // Update an existing staff profile
  updateStaffProfile(
    adminId: string,
    staffData: any,
    staffId: string
  ): Observable<any> {
    const url = this.serverUrl + "/updateStaff?adminId=" + adminId;
    const body = {
      staffId: staffId, // Use the Id from the staffData object
      uid: adminId, // Alternative field name
      name: staffData.Staff_Name__c,
      email: staffData.Staff_Email__c,
      address: staffData.Staff_Address__c,
      isActive: staffData.Is_Active__c,
      role: staffData.Role__c,
      cellPhone: staffData.Staff_Phone__c,
      permissions: staffData.permissions,
    };
    return this._httpClient.put(url, body, this.options);
  }

  // Get staff profile by ID
  getStaffProfile(staffId: string): Observable<any> {
    const url = this.serverUrl + "/getStaffProfile?id=" + staffId;
    return this._httpClient.get(url, this.options);
  }

  // Get all staff profiles
  getAllStaffProfiles(): Observable<any> {
    const url = this.serverUrl + "/getAllStaffProfiles";
    return this._httpClient.get(url, this.options);
  }

  // Delete a staff profile
  deleteStaffProfile(staffId: string): Observable<any> {
    const url = this.serverUrl + "/deleteStaffProfile";
    const body = {
      id: staffId,
    };
    return this._httpClient.post(url, body, this.options);
  }

  // Create a new community (if needed for staff functionality)
  createCommunity(communityData: any, staffId: string): Observable<any> {
    const url = this.serverUrl + "/createCommunity";
    const body = {
      staffId: staffId,
      name: communityData.name,
      description: communityData.description,
      location: communityData.location,
      isPublic: communityData.isPublic,
      isActive: true,
    };
    return this._httpClient.post(url, body, this.options);
  }

  // Create a new program (if needed for staff functionality)
  createProgram(programData: any, staffId: string): Observable<any> {
    const url = this.serverUrl + "/createProgram";
    const body = {
      staffId: staffId,
      name: programData.name,
      description: programData.description,
      category: programData.category,
      ageGroup: programData.ageGroup,
      location: programData.location,
      startDate: programData.startDate,
      endDate: programData.endDate,
      isActive: true,
    };
    return this._httpClient.post(url, body, this.options);
  }

  // Get data from cache (if needed)
  getDataFromCache(): Observable<any> {
    const url = this.serverCache + "/getDataFromCache";
    return this._httpClient.get(url, this.options);
  }

  // Submit contact form (reusing existing functionality)
  submitContactForm(contactData: any): Observable<any> {
    const url = this.serverUrl + "/submitContactForm";
    const body = {
      name: contactData.name,
      email: contactData.email,
      subject: contactData.subject,
      message: contactData.message,
    };
    return this._httpClient.post(url, body, this.options);
  }
}
